import * as React from 'react'

import cn from '@config/tailwind/cn'

import { typographyVariants } from '../lib'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot='textarea'
      className={cn(
        'ui:field-sizing-content ui:min-h-16 ui:w-full ui:rounded-lg ui:border ui:border-outline ui:bg-neutral-white ui:px-2.5 ui:py-2 ui:text-neutral-black ui:transition-colors ui:outline-none ui:placeholder:text-grey-60 ui:focus-visible:border-blue-100 ui:focus-visible:ring-[3px] ui:focus-visible:ring-blue-20 ui:disabled:pointer-events-none ui:disabled:cursor-not-allowed ui:disabled:bg-grey-10 ui:disabled:opacity-50 ui:aria-invalid:border-error ui:aria-invalid:ring-[3px] ui:aria-invalid:ring-error-container',
        typographyVariants({ variant: 'body-lg' }),
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
